import {Component, OnInit, Injector, AfterViewInit, Input, OnDestroy} from '@angular/core';
import {IchWizardpointType, IEntrySignalScanBlock, IEntrySignalsScanData, chartingSaved, entrysignalsSaved} from '../interfaces/scanner.interfaces';
import {ScannerSide, scanDirection, ScannerPrimarySearchList} from '../interfaces/scanner.enums';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {historyPeriods, HistoryItemPeriod} from '../../../interfaces/historyItem';

@Component({
    selector: 'app-scanner-EntrySignalsSelector',
    template: require('./scanner-EntrySignalsSelector.component.html'),
    styles: [require('./scanner-EntrySignalsSelector.component.scss')]
})
export class ScannerEntrySignalsSelectorComponent extends AppComponentBase implements OnInit, AfterViewInit, OnDestroy {

    ngAfterViewInit(): void {

        let v = this.workspace.initLoadScan;
        if(v != null) {
            this.loadScanData(v);
            // this.workspace.initLoadScan = null;
        }

    }

    constructor(injector: Injector) {
        super(injector);


        this.workspace.globaGridMode.loadScannerRule.subscribe(v => {

            //     if(v.primary == ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS)
            this.loadScanData(v)

        });

    }

    ngOnDestroy() {
        //    this.subscribers.load.unsubscribe();
    }

    public subscribers: any = {};





    public loaderSubscribed: boolean = false;
    public _narrowScannerMode: boolean = false;

    @Input() public set narrowScannerMode(value: boolean) {
        this._narrowScannerMode = value
    }

    public get narrowScannerMode() {
        return this._narrowScannerMode;
    }



    public loadScanData(v: any) {

        this.scanRule = {
            LData: {},
            SData: {},
            MData: {},
            EData: {},
        };

        this.targetDirection = [this.scanRule.LData, this.scanRule.MData, this.scanRule.SData, this.scanRule.EData];




        let loadScanData: entrysignalsSaved = (!this.narrowScannerMode) ? <entrysignalsSaved> v.savedData : <entrysignalsSaved> v.savedDataSecondary;


        if(loadScanData.primary != ScannerPrimarySearchList.SCANNER_ENTRYSIGNALS) {
            return
        }



        console.log(v);
        let scanRule: IEntrySignalsScanData = <IEntrySignalsScanData> loadScanData.rule;

        this.onChangeL(scanRule.LData.period);
        this.onChangeM(scanRule.MData.period);
        this.onChangeS(scanRule.SData.period);
        this.onChangeE(scanRule.EData.period);


        if(scanRule.LData.direction == 1) {
            this.setActiveUp(0);
        }

        if(scanRule.LData.direction == -1) {
            this.setActiveDown(0);
        }

        if(scanRule.MData.direction == 1) {
            this.setActiveUp(1);
        }

        if(scanRule.MData.direction == -1) {
            this.setActiveDown(1);
        }

        if(scanRule.SData.direction == 1) {
            this.setActiveUp(2);
        }

        if(scanRule.SData.direction == -1) {
            this.setActiveDown(2);
        }

        if(scanRule.EData.direction == 1) {
            this.setActiveUp(3);
        }

        if(scanRule.EData.direction == -1) {
            this.setActiveDown(3);
        }
        this.workspace.canSelectedSavedScanUpdate = false;

        this.workspace.allowScanProcess = true;
    }


    ngOnInit() {
        this.onChangeL(this.selectL);
        this.onChangeM(this.selectM);
        this.onChangeS(this.selectS);
        this.onChangeE(this.selectE);
        this.allowScanProcess();
    }


    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(value: {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[]) {
        this.workspace.periodsList = value;
    }

    private _scanRule: IEntrySignalsScanData = {
        LData: {},
        SData: {},
        MData: {},
        EData: {},
    };
    public get scanRule(): IEntrySignalsScanData {
        return this._scanRule;
    }
    public set scanRule(value: IEntrySignalsScanData) {
        this._scanRule = value;
    }


    private _selectL: HistoryItemPeriod = HistoryItemPeriod.Hr24;
    public get selectL(): HistoryItemPeriod {
        return this._selectL;
    }
    public set selectL(value: HistoryItemPeriod) {
        
        this._selectL = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);

        this.scanRule.LData.period = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


        //console.log(this.workspace.scannerCurrentRule);
    }

    private _selectM: HistoryItemPeriod = HistoryItemPeriod.Hr6;
    public get selectM(): HistoryItemPeriod {
        return this._selectM;
    }
    public set selectM(value: HistoryItemPeriod) {
        this._selectM = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;
        this.scanRule.MData.period = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    private _selectS: HistoryItemPeriod = HistoryItemPeriod.Hr3;
    public get selectS(): HistoryItemPeriod {
        return this._selectS;
    }
    public set selectS(value: HistoryItemPeriod) {
        this._selectS = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;
        this.scanRule.SData.period = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }

    private _selectE: HistoryItemPeriod = HistoryItemPeriod.Min30;
    public get selectE(): HistoryItemPeriod {
        return this._selectE;
    }
    public set selectE(value: HistoryItemPeriod) {
        this._selectE = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;
        this.scanRule.EData.period = this.workspace.getCorrectPeriod(<HistoryItemPeriod>value);;

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }

    }



    onChangeL(newObj: any) {
        this.selectL = newObj;
    }

    onChangeM(newObj: any) {
        this.selectM = newObj;
    }

    onChangeS(newObj: any) {
        this.selectS = newObj;
    }

    onChangeE(newObj: any) {
        this.selectE = newObj;
    }


    public setActiveUp(i: number) {


        if(this.targetDirection[i].direction != scanDirection.SCAN_ENTRY_UP) {
            this.targetDirection[i].direction = scanDirection.SCAN_ENTRY_UP;
            this.allDown = false;
        }
        else {
            this.targetDirection[i].direction = undefined;
            this.allUp = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }


        if(this.targetDirection[0].direction == scanDirection.SCAN_ENTRY_UP &&
            this.targetDirection[1].direction == scanDirection.SCAN_ENTRY_UP &&
            this.targetDirection[2].direction == scanDirection.SCAN_ENTRY_UP &&
            this.targetDirection[3].direction == scanDirection.SCAN_ENTRY_UP
        ) {
            this.allUp = true;
        }

        this.onChangeL(this.selectL);
        this.onChangeM(this.selectM);
        this.onChangeS(this.selectS);
        this.onChangeE(this.selectE);
        
        this.allowScanProcess()
    }

    public get isDirectionSelected() {
        return this.allDown || this.allUp;
    }

    public setActiveDown(i: number) {

        if(this.targetDirection[i].direction != scanDirection.SCAN_ENTRY_DOWN) {
            this.targetDirection[i].direction = scanDirection.SCAN_ENTRY_DOWN;
            this.allUp = false;

        }
        else {
            this.targetDirection[i].direction = undefined;
            this.allDown = false;
        }

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }



        if(this.targetDirection[0].direction == scanDirection.SCAN_ENTRY_DOWN &&
            this.targetDirection[1].direction == scanDirection.SCAN_ENTRY_DOWN &&
            this.targetDirection[2].direction == scanDirection.SCAN_ENTRY_DOWN &&
            this.targetDirection[3].direction == scanDirection.SCAN_ENTRY_DOWN
        ) {
            this.allDown = true;
        }

        this.onChangeL(this.selectL);
        this.onChangeM(this.selectM);
        this.onChangeS(this.selectS);
        this.onChangeE(this.selectE);


        this.allowScanProcess()
    }


    public loop: number[] = [0, 1, 2, 3]
    public targetDirection: IEntrySignalScanBlock[] = [this.scanRule.LData, this.scanRule.MData, this.scanRule.SData, this.scanRule.EData];


    public get targetDirectionData(): IEntrySignalScanBlock[] {
        return this.targetDirection;
    }

    private _allUp: boolean = false;
    public get allUp(): boolean {
        return this._allUp;
    }
    public set allUp(value: boolean) {
        this._allUp = value;
    }

    private _allDown: boolean = false;
    public get allDown(): boolean {
        return this._allDown;
    }
    public set allDown(value: boolean) {
        this._allDown = value;
    }


    public allUpAction() {
        this.allUp = !this.allUp

        if(this.allUp) {
            this.targetDirection.forEach(v => {
                v.direction = scanDirection.SCAN_ENTRY_UP
            })
            this.allDown = false;
        }
        else {
            this.targetDirection.forEach(v => {
                v.direction = undefined
            })
        }

        this.allowScanProcess()

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {

            this.scanRule.EData.period = this.selectE
            this.scanRule.LData.period = this.selectL
            this.scanRule.MData.period = this.selectM
            this.scanRule.SData.period = this.selectS

            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }

    }

    public allDownAction() {
        this.allDown = !this.allDown

        if(this.allDown) {
            this.targetDirection.forEach(v => {
                v.direction = scanDirection.SCAN_ENTRY_DOWN
            });
            this.allUp = false;
        }
        else {
            this.targetDirection.forEach(v => {
                v.direction = undefined
            })
        }

        this.allowScanProcess()

        if(!this.narrowScannerMode) {
            this.workspace.scannerCurrentRule = JSON.parse(JSON.stringify(this.scanRule));

        }
        else {
            this.scanRule.EData.period = this.selectE
            this.scanRule.LData.period = this.selectL
            this.scanRule.MData.period = this.selectM
            this.scanRule.SData.period = this.selectS
            this.workspace.scannerCurrentRule_Narrow = JSON.parse(JSON.stringify(this.scanRule));
        }
    }



    public allowScanProcess() {

        
        if(!this.narrowScannerMode) {
            if(
                this.targetDirection[0].direction == undefined &&
                this.targetDirection[1].direction == undefined &&
                this.targetDirection[2].direction == undefined &&
                this.targetDirection[3].direction == undefined
            ) {
                this.workspace.allowScanProcess = false;
            }
            else {
                this.workspace.allowScanProcess = true;
            }
        }
    }


    public onShown(e: any) {

    }

}




